import api from "config/axios.config";
import { Admin } from "types/admin.type";

export const findOrCreateAdmin = (
  uid: string,
  email: string
): Promise<Admin> => {
  return api.get(`/admins/uid/${uid}/email/${email}`);
};
